/**
 * Author: Busola Oladipo
 * Created: 2025-02-23
 * Description: Puzzle CAPTCHA component for verifying user interactions.
 */
import {
  Component,
  EventEmitter,
  OnInit,
  Output,
  ViewChild,
  ElementRef,
  AfterViewInit,
} from '@angular/core';

@Component({
  selector: 'app-puzzle-captcha',
  templateUrl: './puzzle-captcha.component.html',
  styleUrls: ['./puzzle-captcha.component.css'],
  standalone: false,
})
export class PuzzleCaptchaComponent implements OnInit, AfterViewInit {
  @Output() captchaResult = new EventEmitter<boolean>();
  @ViewChild('captchaBox') captchaBox!: ElementRef;

  boxX: number = 0;
  boxY: number = 0;
  message: string = 'Click on the box to verify.';
  success: boolean = false;
  isDisabled: boolean = false;
  clickMarkerVisible: boolean = false;
  clickedX: number | null = null;
  clickedY: number | null = null;
  showCaptcha: boolean = true;
  checkboxChecked: boolean = false;
  timeoutId: any;
  failedAttempts: number = 0;

  ngOnInit() {
    this.generateNewCaptcha();
  }

  ngAfterViewInit() {
    if (!this.captchaBox) {
      console.error('captchaBox is not available');
    }
  }

  generateNewCaptcha() {
    this.boxX = Math.floor(Math.random() * 200) + 50;
    this.boxY = Math.floor(Math.random() * 100) + 20;

    this.success = false;
    this.message = 'Click on the box to verify.';
    this.isDisabled = false;
    this.clickMarkerVisible = false;
    this.showCaptcha = true;
    this.checkboxChecked = false;

    clearTimeout(this.timeoutId);

    this.timeoutId = setTimeout(() => {
      if (!this.success) {
        this.generateNewCaptcha();
      }
    }, 5000);
  }

  checkClick(event: MouseEvent) {
    if (!this.captchaBox || this.isDisabled) return;

    const captchaRect = this.captchaBox.nativeElement.getBoundingClientRect();
    const clickX = event.clientX - captchaRect.left;
    const clickY = event.clientY - captchaRect.top;

    this.clickedX = clickX;
    this.clickedY = clickY;
    this.clickMarkerVisible = true;

    const boxWidth = 40;
    const boxHeight = 40;

    if (
      this.clickedX >= this.boxX &&
      this.clickedX <= this.boxX + boxWidth &&
      this.clickedY >= this.boxY &&
      this.clickedY <= this.boxY + boxHeight
    ) {
      this.checkboxChecked = true;
      this.success = true;
      this.message = '✅ CAPTCHA Verified!';
      this.isDisabled = true;

      clearTimeout(this.timeoutId);

      setTimeout(() => {
        this.showCaptcha = false;
        this.captchaResult.emit(true);
      }, 1000);
    } else {
      this.failedAttempts++;
      this.message = `❌ Wrong Spot! Try Again. (${this.failedAttempts}/3)`;

      if (this.failedAttempts >= 3) {
        this.message = '❌ Maximum attempts reached!';
        this.isDisabled = true;
        setTimeout(() => {
          this.captchaResult.emit(false);
          this.generateNewCaptcha();
        }, 1000);
      }
    }
  }
}
